import React from 'react';
import HighchartsReact from 'highcharts-react-official';

/**
 * @param chartRef - HighchartsReactコンポーネントへのref
 *
 * HighchartsReact コンポーネントのサイズ変更を監視し、
 * サイズが変わった際にチャートを再描画（reflow）するフック
 * 主にサイドバー開閉時にグラフ幅が変わらない問題を解決するために使用
 */

export const useChartResizeObserver = (chartRef: React.RefObject<HighchartsReact.RefObject>) => {
  React.useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      chartRef.current?.chart.reflow();
    });

    if (chartRef.current?.container.current) {
      resizeObserver.observe(chartRef.current.container.current);
    }

    return () => {
      if (chartRef.current?.container.current) {
        resizeObserver.unobserve(chartRef.current.container.current);
      }
    };
  }, [chartRef]);
};
